import { Select } from 'entities/Select'
import { bookingOptions } from './options'
import { useConfigStore } from 'shared/store/configSlice'

export const ScheduleIntervalsSelector = () => {
  const updateTableReservationConfig = useConfigStore().updateTableReservationConfig
  const bookingPossibility = useConfigStore().config?.tableReservationConfig?.bookingPossibility

  const updateDaysOff = (valueToSet: number | string) => {
    if (Number.isFinite(valueToSet)) {
      updateTableReservationConfig({ bookingPossibility: valueToSet as number })
    }
  }

  return (
    <Select
      key={`booking_possibility_${bookingPossibility}`}
      value={bookingPossibility}
      options={bookingOptions}
      onChange={updateDaysOff}
    />
  )
}
